import React from 'react';
import { RiCloseLine } from 'react-icons/ri';

export interface FilterTag {
  key: string;
  label: string;
  value: string;
  color?: 'secondary' | 'primary' | 'success' | 'warning' | 'accent';
}

interface ActiveFilterTagsProps {
  tags: FilterTag[];
  onRemove: (key: string) => void;
  className?: string;
}

const colorClasses = {
  secondary: 'bg-secondary-100 text-secondary-700',
  primary: 'bg-primary-100 text-primary-700',
  success: 'bg-success-100 text-success-700',
  warning: 'bg-warning-100 text-warning-700',
  accent: 'bg-accent-100 text-accent-700',
};

const ActiveFilterTags: React.FC<ActiveFilterTagsProps> = ({
  tags,
  onRemove,
  className = '',
}) => {
  if (tags.length === 0) return null;

  return (
    <div className={`flex items-center flex-wrap gap-2 pt-3 border-t border-secondary-100 ${className}`}>
      <span className="text-sm text-secondary-500">กรองแสดง:</span>
      {tags.map((tag) => (
        <span
          key={tag.key}
          className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
            colorClasses[tag.color || 'secondary']
          }`}
        >
          {tag.label}: "{tag.value}"
          <button
            onClick={() => onRemove(tag.key)}
            className="ml-1.5 hover:opacity-70 focus:outline-none"
            title={`ลบตัวกรอง ${tag.label}`}
          >
            <RiCloseLine className="w-3.5 h-3.5" />
          </button>
        </span>
      ))}
    </div>
  );
};

export default ActiveFilterTags;
